module.exports = __webpack_public_path__ + "img/4-3.6b0a1ce5.svg";